/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* =============================================================
   3BUTE — Productnaam altijd op 1 regel
   Verkleint het font van de producttitel (h1.product-meta__title)
   net zo lang tot de volledige naam op 1 regel past, ongeacht de
   lengte. Werkt samen met de basis font-size uit custom.css.
   ============================================================= */
(function () {
  function initProductTitleFit() {
    var el = document.querySelector('.product-meta__title');
    if (!el) return;

    // Capture the CSS-defined size once, before any inline override,
    // so repeated fits (e.g. on resize) always start from the same
    // baseline instead of shrinking a little further every time.
    var baseFontSize = parseFloat(getComputedStyle(el).fontSize);
    var minFontSize = 14;

    function fit() {
      el.style.whiteSpace = 'nowrap';
      el.style.overflow = 'hidden';

      var fontSize = baseFontSize;
      el.style.fontSize = fontSize + 'px';

      var attempts = 0;
      while (el.scrollWidth > el.clientWidth && fontSize > minFontSize && attempts < 40) {
        fontSize -= 1;
        el.style.fontSize = fontSize + 'px';
        attempts++;
      }
    }

    fit();
    window.addEventListener('load', fit);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fit, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTitleFit);
  } else {
    initProductTitleFit();
  }
})();


/* =============================================================
   3BUTE — Aantal-stepper + "Toevoegen aan winkelwagen" als eigen
   volle-breedte balk, links uitgelijnd met "Toevoegen aan Mijn
   Favorieten" eronder
   .product-form__info-list is een display:table layout (label-
   kolom + content-kolom, gedeeld over de Prijs/Voorraad/Aantal-
   rijen). Puur CSS (display:block op de content) volstaat niet om
   de Aantal-rij daaruit los te maken: zolang het element nog een
   kind van een tabel-rij is, genereert de browser er automatisch
   een anonieme 1-koloms tabel omheen, en blijft de content beperkt
   tot de oorspronkelijke kolombreedte. Daarom verplaatsen we
   .product-form__info-content (stepper + BSS-staffeltabel) hier
   letterlijk in de DOM naar een positie NA .product-form__info-list
   (dus volledig buiten de tabel-structuur) en verplaatst de
   "Toevoegen aan winkelwagen"-knop (.product-form__payment-
   container) daar weer naar binnenin, naast de stepper. De
   "Toevoegen aan Mijn Favorieten"-knop (.nm-portal, wishlist-app)
   blijft bewust in .product-form__buy-buttons staan, dus die blijft
   gewoon onder de staffeltabel staan zoals voorheen.
   Puur een DOM-verplaatsing via JS — er wordt niets aan de native
   Liquid-templates gewijzigd. Draait ook op 'variant:changed'/
   'shopify:section:load' zodat alles ook na een eventuele
   section-herrender op zijn plek blijft staan.
   ============================================================= */
(function () {
  function moveQuantityAndBuyButton() {
    var infoList = document.querySelector('.product-form__info-list');
    var qtyContent = document.querySelector('.product-form__info-item--quantity .product-form__info-content');
    var quantityWrapper = document.querySelector('.product-form__quantity-with-rules');
    var paymentContainer = document.querySelector('.product-form__buy-buttons .product-form__payment-container');

    if (infoList && qtyContent && !qtyContent.classList.contains('bute-quantity-buybar')) {
      qtyContent.classList.add('bute-quantity-buybar');
      infoList.parentNode.insertBefore(qtyContent, infoList.nextSibling);
    }

    if (quantityWrapper && paymentContainer && paymentContainer.parentElement !== quantityWrapper) {
      quantityWrapper.appendChild(paymentContainer);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveQuantityAndBuyButton);
  } else {
    moveQuantityAndBuyButton();
  }

  document.addEventListener('variant:changed', moveQuantityAndBuyButton);
  document.addEventListener('shopify:section:load', moveQuantityAndBuyButton);
})();
